import Image from '@segment/matcha/components/Image'

import makeItAContinuousConversationPng2x from './assets/MakeItAContinuousConversation@2x.png'
import makeItAContinuousConversationWebp from './assets/MakeItAContinuousConversation.webp'
import makeItAContinuousConversationWebp2x from './assets/MakeItAContinuousConversation@2x.webp'

const MakeItAContinuousConversationImage = () => {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${makeItAContinuousConversationWebp}, ${makeItAContinuousConversationWebp2x} 2x`}
      />
      <Image
        width="585"
        height="411"
        src={makeItAContinuousConversationPng2x}
        alt="Illustration: Make it a continuous conversation"
        loading="lazy"
      />
    </picture>
  )
}

export default MakeItAContinuousConversationImage
